import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';
import {useMenu} from '../../../hooks/useMenu';
import TrialLicense from './trial';

function TrialTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);
  const {onComponent} = useMenu();

  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={54}
      defaultKey4={0}
      defaultKey5={0}
      defaultKey6={0}
      defaultKey7={0}
      defaultKey8={0}
      defaultKey9={0}
      defaultKey10={0}
      defaultKey11={0}
      defaultKey12={0}
      onSave={() => onComponent(<TrialLicense />)}
      onLeftHold={onExit}
      title="Trial License"
      caption="Enter Trial License"
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default TrialTN;
